import { mapState } from 'vuex';
import makeToast from './makeToast';

const login = {
  mixins: [makeToast],
  computed: {
    ...mapState(['dadosUsuario']),
  },
  methods: {
    login(key, password, payment=false, demoApp=false) {
      const data = {
        email: key,
        password,
      };

      this.$store.dispatch('startLoader');
      this.$store.dispatch('loadLogin', data)
        .then(() => {
          if (this.dadosUsuario !== null) {
            this.makeToast('Sucesso', 'Login realizado com sucesso!');

            if(payment == true) {
              this.$router.push({ name: 'lojista-cartão-credito-app-ass' });
              return;
            }

            if(demoApp == true) {
              this.$router.push({ name: 'lojista-customizacoes-mudar-cor' });
              return;
            }

            if (this.dadosUsuario.tipo_usuario === 'Cliente') {
              this.$router.push({ name: 'cliente-meus-dados' });
            } else if (this.dadosUsuario.tipo_usuario === 'Lojista') {
              this.$router.push({ name: 'lojista-iugu-dash' });
            } else if (this.dadosUsuario.tipo_usuario === 'Profissional') {
              this.$router.push({ name: 'profissional-meu-perfil' });
            } else if (this.dadosUsuario.tipo_usuario === 'Representante') {
              this.$router.push({ name: 'representante-meus-dados' });
            } else if (this.dadosUsuario.tipo_usuario === 'Editor') {
              this.$router.push({ name: 'editor-meus-dados' });
            } else if (this.dadosUsuario.tipo_usuario === 'Administrador') {
              this.$router.push({ name: 'administrador-meus-dados' });
            } else if (this.dadosUsuario.tipo_usuario === 'Parceiro') {
              this.$router.push({ name: 'parceiro-portfolio' });
            } else if (this.dadosUsuario.tipo_usuario === 'Balconista') {
              this.$router.push({ name: 'balconista-meus-dados' });            
            } else if (this.dadosUsuario.tipo_usuario === 'Gerente de conta') {
              this.$router.push({ name: 'gerente-meus-dados' });
            }
            this.$store.dispatch('endLoader');
          } else {
            this.$store.dispatch('endLoader');
            this.makeToast('Oops', 'Parece que seu email ou sua senha estão incorretos!', 'danger');
          }
        })
        .catch((error) => {
          this.makeToast('Oopss!', error.response.data.message, 'danger');
        });
    },
  },
};

export default login;
